/* global APPLICATION_VERSION */

// See https://docs.sentry.io/platforms/javascript/?platform=browser#browser-table
import 'core-js/es/promise';
import 'core-js/es/object/assign';
import 'core-js/es/number/is-nan';
import 'core-js/es/string/includes';

import * as Sentry from '@sentry/browser';

export const makeClientOption = (options = {}) => ({
  dsn: window.ENVS.SENTRY_DSN,
  environment: process.env.NODE_ENV,
  release: `viddsee_api@${(window.ENVS.APPLICATION_VERSION).trim()}`,
  beforeSend(event) {
    if (process.env.NODE_ENV !== 'production') {
      if (event.contexts && event.contexts.vue) {
        // Restore error logging of vue error during deveopment
        // This is done to work around https://github.com/vuejs/vue/issues/8433 & https://github.com/getsentry/sentry-javascript/issues/1416
        // eslint-disable-next-line no-console
        console.error(event);
      }
    }

    event.tags.url = window.location.href;
    event.tags.userAgent = window.navigator.userAgent;
    event.tags.locale = window.I18n && window.I18n.locale;
    event.tags.windowWidth = window.innerWidth;
    event.tags.windowHeight = window.innerHeight;

    return event;
  },
  ...options,
});

export const getSentryInstance = () => window.Sentry || Sentry;

export const initializeSentry = (options) => {
  const clientOption = makeClientOption(options);

  const sentryInstance = getSentryInstance();

  if (window.Sentry) {
    sentryInstance.getCurrentHub().bindClient(
      new sentryInstance.BrowserClient(clientOption),
    );
  } else {
    sentryInstance.init(clientOption);
    window.Sentry = sentryInstance;
  }

  sentryInstance.configureScope((scope) => {
    scope.setTag('project', 'viddsee_api_client');
  });
};
